// 核心类型定义
// 坐标约定 (ICCS 标准):
//   file 0..8  (列, 红方视角从左到右 a→i)
//   rank 0..9  (行, 从下到上; a0 = 红方左下角)
//   square = rank * 9 + file   范围 0..89

export type Color = 'r' | 'b';

// 大写=红, 小写=黑 (与 FEN 一致)
export type PieceType = 'K' | 'A' | 'B' | 'N' | 'R' | 'C' | 'P';

export interface Piece {
  color: Color;
  type: PieceType;
}

export type Square = number; // 0..89

export interface Move {
  from: Square;
  to: Square;
  captured?: Piece;
}

export interface GameState {
  board: (Piece | null)[]; // 长度 90, board[rank*9+file]
  turn: Color; // 'r' 红走, 'b' 黑走
  halfmove: number; // no-capture/no-pawn 半回合计数, 达 120 判和
  fullmove: number; // 总回合, 起始 1
}

// FEN 字母表 (大小写区分颜色)
export const PIECE_LETTERS: Record<PieceType, string> = {
  K: 'k', A: 'a', B: 'b', N: 'n', R: 'r', C: 'c', P: 'p',
};

// 中文棋字
export const CHAR_RED: Record<PieceType, string> = {
  K: '帅', A: '仕', B: '相', N: '傌', R: '俥', C: '炮', P: '兵',
};
export const CHAR_BLACK: Record<PieceType, string> = {
  K: '将', A: '士', B: '象', N: '馬', R: '車', C: '砲', P: '卒',
};

// ----- 坐标辅助 -----
export const FILES = 9;
export const RANKS = 10;
export const NUM_SQUARES = FILES * RANKS; // 90

export function fileOf(sq: Square): number { return sq % 9; }
export function rankOf(sq: Square): number { return Math.floor(sq / 9); }
export function makeSquare(file: number, rank: number): Square { return rank * 9 + file; }

export function inBounds(file: number, rank: number): boolean {
  return file >= 0 && file < 9 && rank >= 0 && rank < 10;
}

// 红方在底 (rank 0..4); 黑方在顶 (rank 5..9). 河在 rank 4 与 rank 5 之间.
export function crossedRiver(color: Color, rank: number): boolean {
  return color === 'r' ? rank >= 5 : rank <= 4;
}

// 九宫: file ∈ [3,5]; 红限 rank 0-2, 黑限 rank 7-9.
export function inPalace(color: Color, file: number, rank: number): boolean {
  if (file < 3 || file > 5) return false;
  if (color === 'r') return rank >= 0 && rank <= 2;
  return rank >= 7 && rank <= 9;
}

// 棋子属于哪方 (大写红, 小写黑)
export function opposite(color: Color): Color { return color === 'r' ? 'b' : 'r'; }

// 起始 FEN (与 xiangqi.js DEFAULT_POSITION 一致)
export const START_FEN =
  'rnbakabnr/9/1c5c1/p1p1p1p1p/9/9/P1P1P1P1P/1C5C1/9/RNBAKABNR r - - 0 1';
